export const LOCAL_DEV_ACCESS_COOKIE = "revnus-local-access-email";
export const LOCAL_DEV_ACCESS_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export const LOCAL_DEV_ACCESS_PROFILES = [
  {
    email: "dev@revnus.com",
    name: "Local Developer",
    role: "ADMIN",
    label: "Dev",
    description: "Developer tools",
  },
  {
    email: "admin@mybusiness.local",
    name: "Local Admin",
    role: "ADMIN",
    label: "Admin",
    description: "Full app access",
  },
  {
    email: "employee@mybusiness.local",
    name: "Local Employee",
    role: "EMPLOYEE",
    label: "Employee",
    description: "Employee permissions",
  },
] as const;

export const LOCAL_DEV_ACCESS_EMAILS = LOCAL_DEV_ACCESS_PROFILES.map((profile) => profile.email);

export function getLocalDevAccessRedirectPath(email: string | null | undefined) {
  const normalizedEmail = email?.toLowerCase() ?? "";
  if (normalizedEmail === "dev@revnus.com") {
    return "/dev/users";
  }

  // Keep local testing on stable working pages instead of the heavy dashboard.
  if (normalizedEmail === "employee@mybusiness.local") {
    return "/projects?view=timesheets";
  }

  return "/projects";
}

export function isLocalHost(host: string) {
  const normalizedHost = host.toLowerCase();
  return normalizedHost.startsWith("localhost:") || normalizedHost.startsWith("127.0.0.1:") || normalizedHost === "localhost" || normalizedHost === "127.0.0.1";
}

export function isLocalDevAccessEmail(email: string | null | undefined) {
  if (!email) {
    return false;
  }

  return LOCAL_DEV_ACCESS_EMAILS.includes(email.toLowerCase() as (typeof LOCAL_DEV_ACCESS_EMAILS)[number]);
}

export function getLocalDevAccessProfile(email: string | null | undefined) {
  const normalizedEmail = email?.toLowerCase() ?? "";
  return LOCAL_DEV_ACCESS_PROFILES.find((profile) => profile.email === normalizedEmail) ?? null;
}
